// extracted by mini-css-extract-plugin
module.exports = {"authorDetails":"az_-nd","nickname":"az_-od","date":"az_-pd"};